import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "lead-time-reduction",
    iconColor: "white",
    text: "Faster resolution time",
    listItemCustomStyle: { width: "252px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "graphDownArrowWithDollarSign",
    iconColor: "white",
    text: "OpEx cost reduction",
    listItemCustomStyle: { width: "252px" },
    textCustomStyle: {
      fontSize: "24px",
      letterSpacing: "0.24px",
      marginTop: "30px",
    },
  },
  {
    icon: "automatic-case",
    iconColor: "white",
    text: "Automatic case and\nnotification creation",
    listItemCustomStyle: { width: "252px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

const DATA_BENEFITS_IEAM_1 = {
  title: "Closed Loop Assurance",
  subtitle: "Automatic case and notification creation",
  titleNumber: "1.",
  text: "\nProviding recommended resolutions for the agent to achieve \nfaster resolution times.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "NEXT",
    onClick: () => setCurrentPage("ILO_203"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_201"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO2/ILO2_Introduction_02.png",
};

export default DATA_BENEFITS_IEAM_1;
